import React, { useRef, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import ReactQuill, { Quill } from 'react-quill';
import { updateBeforeCallsImportantInfoForm } from '../../../../actions/waitingArea.js';
import 'react-quill/dist/quill.snow.css';
import { addLinkHandler } from 'businessLogic/quillEditor.js';

export default function CenterPanel(props) {
  const quillRef = useRef(null); // Quill instance
  const reactQuill = useRef(null); // ReactQuill component
  const quillEditor = useRef();

  const dispatch = useDispatch();

  useEffect(() => {
    addReactQuillRef();

    const inputQlEditor = document.querySelector('input[data-link]');
    inputQlEditor.dataset.link = 'http:// or https://';
    inputQlEditor.placeholder = 'http:// or https://';
  }, []);

  const addReactQuillRef = () => {
    // Ensure React-Quill reference is available:
    if (typeof reactQuill.current.getEditor !== 'function') return;
    // Skip if Quill reference is defined:
    if (quillEditor.current != null) return;

    const quillEditorLocal = reactQuill.current.getEditor();
    quillEditor.current = quillEditorLocal;
  };

  const beforeCallsImportantInfoFormUpdated = (value, delta, source, editor) => {
    let showCharLimitWarning = false;
    let ifTextEmpty = false;
    if (quillEditor.current != null) {
      let lines = quillEditor.current.getLines().length;
      let charLength = quillEditor.current.getLength();

      if (
        lines > props.beforeCallsImportantInfoForm.importantInfo.maxLineLength ||
        charLength > props.beforeCallsImportantInfoForm.importantInfo.maxCharLength
      ) {
        showCharLimitWarning = true;
      } else {
        showCharLimitWarning = false;
      }

      if (editor != null) {
        let text = editor.getText().trim();
        const re = /\S/;
        if (!re.test(text)) {
          ifTextEmpty = true;
        }
      }
    }
    dispatch(updateBeforeCallsImportantInfoForm(value, showCharLimitWarning, ifTextEmpty));
  };

  return (
    <div>
      <div className="ui form">
        <label id="before-call-important-info-caption" className="placeholder-label no-bold color-placeholder div-like">
          {APP.LANGUAGE.WaitingAreaBeforeCallsImportantInfo.TitlePartOne}
          <div className="inline-flex">{APP.LANGUAGE.WaitingAreaBeforeCallsImportantInfo.TitlePartTwo}</div>
        </label>
        <div style={{ userSelect: 'auto' }}>
          <ReactQuill
            ref={reactQuill}
            modules={CenterPanel.modules}
            value={props.beforeCallsImportantInfoForm.importantInfo.value || ''}
            placeholder={APP.LANGUAGE.WaitingAreaBeforeCallsImportantInfo.Title}
            onChange={beforeCallsImportantInfoFormUpdated}
            className="rich-text-editor"
          />
        </div>
        {props.beforeCallsImportantInfoForm.importantInfo.showCharLimitWarning ? (
          <div className="small-font-size mrtxxs color-warning">
            <div className="right-text no-bold">
              {APP.LANGUAGE.WaitingAreaBeforeCallsImportantInfo.ExceedLimitWarning}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

CenterPanel.modules = {
  toolbar: {
    container: [
      [{ header: ['1', '2', '3', '0'] }],
      ['bold', 'italic', 'underline'],
      ['link'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['clean'],
    ],
    handlers: {
      link: addLinkHandler,
    },
  },
  clipboard: {
    matchVisual: false,
  },
};
